import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import Spinner from 'react-bootstrap/Spinner';
import { onError } from "../libs/errorLib";
import { API } from 'aws-amplify';
import Plot from 'react-plotly.js';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { startCase, camelCase} from 'lodash';
import { myListSciHackFiles } from '../graphql/my.queries';

// custom data fetching/processing hook
// https://www.robinwieruch.de/react-hooks-fetch-data
const useRestApi = (Description, FileName) => {
  const [description, setDescription] = useState(Description);
  const [fileName, setFileName] = useState(FileName);
  const [isComputing, setIsComputing] = useState(false);
  const [isError, setIsError] = useState(false);
  const [dataCols, setDataCols] = useState({});
  const [dataRows, setDataRows] = useState({});

  const apiName = 'SciHackRestApi';
  const path = '/analyse';
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: { 
      fileName: fileName,
    }
  };
  //console.log(myInit);

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsComputing(true);
 
      try {
        const response = await API.get(apiName, path, myInit);
        //console.log(response.data);
        //console.log(JSON.parse(response.data.output));
        setDataRows(JSON.parse(response.data.output));
        var column_name = response.data.column_name;
        console.log('ID = ' + response.data.ID)
        
        // reformat response.data.output to columns for charting
        var date_arr = [];
        var value_arr = [];
        JSON.parse(response.data.output).forEach((item) => {
          date_arr.push(item.date);
          value_arr.push(item.value);
        });

        // reformat response.data.mean_by_year to columns for charting
        var date_arr1 = [];
        var value_arr1 = [];
        JSON.parse(response.data.mean_by_year).forEach((item) => {
          date_arr1.push(item.Index);
          value_arr1.push(item.value);
        });

        // reformat response.data.mean_by_year to columns for charting
        var date_arr2 = [];
        var value_arr2 = [];
        JSON.parse(response.data.mean_by_month).forEach((item) => {
          date_arr2.push(item.Index);
          value_arr2.push(item.value);
        });

        //console.log('column_name: ' + column_name);
        //console.log('pure_premium: ' + pure_premium);
        //console.log('loaded_premium: ' + response.data.loaded_premium)
        //console.log('loading: ' + response.data.loading);

        setDataCols({'Date': date_arr, 'Value': value_arr, 'ColumnName': column_name, 'MeanByYearIndex': date_arr1, 'MeanByYearValue': value_arr1,
                    'MeanByMonthIndex': date_arr2, 'MeanByMonthValue': value_arr2});

      } catch (error) {
        setIsError(true);
        onError(error);
      }
 
      setIsComputing(false);
    };

    //console.log('Trying fetch : symbol=' + symbol + ' riskDriver=' + riskDriver);
    if (description !== "" && fileName !== "")  {
      fetchData();
      //console.log('Fetch OK! ' + symbol + ' ' + riskDriver);
    }

  }, [description, fileName]);
 
  return [{ dataCols, dataRows, isComputing, isError }, setDescription, setFileName];
};


export default function Analyse() {
  const [isLoading, setIsLoading] = useState(true);
  const [timeSeriess, setTimeSeriess] = useState(null);
  const [description, setDescription] = useState("");
  const [fileName, setFileName] = useState("");
  const [timeSeriesSelected, setTimeSeriesSelected] = useState(false);
  const [unitOfMeasurement, setUnitOfMeasurement] = useState(null)

  const [{ dataCols, dataRows, isComputing, isError }, 
    setDescriptionArg, setFileNameArg] = useRestApi(
      description, fileName);

  useEffect(() => {
    // fetch async data within useEffect hook (not as separate function) otherwise big problems
    // https://blog.logrocket.com/usestate-vs-useref/
    const fetchData = async () => {
      try {
        let filter = {
          fileType: {
              eq: 'csv'
          }
        };
        const apiData = await API.graphql({ query: myListSciHackFiles, variables: { filter: filter} });
        const tsFromApi = apiData.data.listSciHackFiles.items;
        await Promise.all(tsFromApi);
        setTimeSeriess(apiData.data.listSciHackFiles.items);
        //console.log('tsFromApi len = ' + tsFromApi.length);
        //for (const [key, value] of Object.entries(tsFromApi)) {
          //console.log(`${key}: ${value.description}|${value.fileType}|${value.fileName}`);
        //} 
      } catch (error) {
        onError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  function handleInputChange(event) {
    // used for disabling submit button
    switch (event.target.id) {
      case "selectTimeSeries":
        setTimeSeriesSelected(true);
        let timeSeriesParams = document.getElementById('selectTimeSeries').value.split("|");
        setFileName(timeSeriesParams[1]);
        break;
    default:
        console.log("No input change.");
        break;
    }
    //console.log("Input changed: " + event.target.id + " - " + event.target.value);
    //console.log("Input changed: " + event.target.id + " - " + document.getElementById('selectTimeSeries').value);
  }

  function validateForm() {
    // disables submit button if inputs not selected
    return (timeSeriesSelected);
  }

  function handleSubmit(event) {
    let timeSeriesParams = document.getElementById('selectTimeSeries').value.split("|");
    setDescription(timeSeriesParams[0]);
    setDescriptionArg(timeSeriesParams[0]);
    setFileName(timeSeriesParams[1]);
    setFileNameArg(timeSeriesParams[1]);
    if (timeSeriesParams[1] === "sunshine-duration-monthly-mean-daily-duration.csv") {
      setUnitOfMeasurement('Hours');
    } else if (timeSeriesParams[1] === "surface-air-temperature-monthly-mean.csv") {
      setUnitOfMeasurement('Degrees Celsius');
    } else if (timeSeriesParams[1] === "rainfall-monthly-total.csv") {
      setUnitOfMeasurement('Millimetres');
    } else if (timeSeriesParams[1] === "rainfall-monthly-number-of-rain-days.csv") {
      setUnitOfMeasurement('Days');
    }
    event.preventDefault();
  }

  function ControlledTabs(props) {
    return (
      
      <div style={{display: 'block', width: '100%'}}>
        <Tabs defaultActiveKey="chart">
          <Tab eventKey="chart" title="Charts">
              <br />
              <Chart dataCols={props.dataCols}/>
            </Tab>
          <Tab eventKey="description" title="Description">
            <br />
            <Table size="sm" className="table table-borderless">
              <tbody>
              <tr>
                  <td className="col-md-3"><strong>Index:</strong></td>
                  <td className="col-md-9">Singapore: {startCase(description)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Unit of Measurement:</strong></td>
                  <td className="col-md-9">{unitOfMeasurement}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Source:</strong></td>
                  <td className="col-md-9"><a className="rnr" href="https://data.gov.sg/group/environment/" rel="noopener noreferrer" target="_blank">Data.gov.sg National Environment Agency (NEA)</a></td>
                </tr>
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="data" title="Data">
            <br />
            <DataTable dataRows={props.dataRows} dataCols={props.dataCols}/>
          </Tab>
        </Tabs>
      </div>
    );
  }
 
  function Chart(props) {
    var trace0 = {
      x: props.dataCols.Date,
      y: props.dataCols.Value,
      name: startCase(camelCase(props.dataCols.ColumnName)),
      type: "line",
      mode: 'lines',
      marker: {color: '#1f77b4'}, //muted blue
    };

    var trace1 = {
      type: 'bar',
      x: props.dataCols.MeanByMonthIndex,
      y: props.dataCols.MeanByMonthValue,
      marker: {color: '#2ca02c'} // cooked asparagus green
    }
    
    var trace2 = {
      type: 'bar',
      x: props.dataCols.MeanByYearIndex,
      y: props.dataCols.MeanByYearValue,
      marker: {color: '#ff7f0e'} // safety orange
    }

    return (
      <>
      <div>
          <Plot
            data={[trace0]}
            config={ {responsive: true} }
            layout={ {title: startCase(camelCase(props.dataCols.ColumnName)),
                      showlegend: false,

            } }
          />    
      </div>
      <hr className="featurette-divider" />
      <div>
          <Plot
            data={[trace1]}
            config={ {responsive: true} }
            layout={ {title: 'Average By Month: ' + startCase(camelCase(props.dataCols.ColumnName)),
                      showlegend: false,

            } }
          />    
      </div>
      <hr className="featurette-divider" />
      <div>
          <Plot
            data={[trace2]}
            config={ {responsive: true} }
            layout={ {title: 'Average By Year: ' + startCase(camelCase(props.dataCols.ColumnName)),
                      showlegend: false,

            } }
          />    
      </div>
      </>
    );  
  }

  function DataTable(props) {
    // data must be in rows
    //console.log('test dt: ' + props.dataRows);
    const dataTableColumns = [
      {
        dataField: "date",
        text: "Date",
        sort: true
      },
      {
        dataField: "value",
        text: startCase(camelCase(props.dataCols.ColumnName))
      }
    ];
    return (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="Date"
          data={props.dataRows}
          columns={dataTableColumns}
          pagination={paginationFactory({ sizePerPage: 100 })}
          striped
          hover
          condensed
        />
      </div>
    );
  }

  return (
    <main className="flex-shrink-0">
      <div className="container">
        <h4 className="mt-3">Analyse Index Data</h4>
        <br />
        <div className="container">
          <div className="row">
            {isError && <div>Error occurred [useRestApi function?] ...</div>}
            <div className="col-3">
              { isLoading ? (
                <Spinner animation="border" style={{color: "#990000"}}/>
                ) : (
                <>
                <div className="card">
                  <div className="card-body">
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTimeSeries" name="selectTimeSeries">
                          <Form.Label>Monthly Index:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="" key="0">Select index...</option>
                            {
                              Object.entries(timeSeriess).map(([key, value], index) => {
                                return(
                                  <option key={key+1} value={value.description + '|' + value.fileName} data-type="text">{startCase(value.description)}</option>
                                )
                              })
                            }                                
                          </Form.Control>
                        </Form.Group>
                      </Row>
                        <Row>
                        <Form.Group as={Col} size="lg" controlId="buttonSubmit">
                            <LoaderButton
                            size="md"
                            type="submit"
                            isLoading={isComputing}
                            disabled={!validateForm()}
                            >
                            Analyse
                            </LoaderButton>
                        </Form.Group>
                        </Row>
                    </Form>
                  </div>
                </div>
                </>
                )
              }
            </div>
            <div className="col-9">
              { !isComputing && Object.keys(dataCols).length > 0 &&
                <ControlledTabs dataCols={dataCols} dataRows={dataRows} description={description} fileName={fileName}/>
              } 
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}